.scrollbar {
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: white transparent;
}

.scrollbar::-webkit-scrollbar {
  width: 8px;
  background: transparent;
}

.scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar::-webkit-scrollbar-thumb {
  background: white;
  border-radius: 100px;
  border: none;
}

.scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.8);
}
